<template>
  <div v-if="loaded">

    <b-row class="mt-1 w-100">
      <b-col cols="3">
        <b-form-group label="Channel ID" label-for="realEstate-buy-price">
          <b-form-input id="realEstate-buy-price"  v-model="realEstate.channelId"
                        @change="onValueUpdated"/>
        </b-form-group>
      </b-col>


      <b-col cols="3">
        <b-form-group :label="msg('Channel manager reservations')" label-for="realEstate-sell-price">
          <b-button variant="primary" @click="fetchChannelReservations">
            <b-spinner small v-if="channelLoading" class="mr-2"></b-spinner>
            Fetch reservations from channel manager
          </b-button>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group :label="msg('Crm contracts out of channel manager')" label-for="realEstate-sell-price">
          <b-badge variant="primary">
            {{ totalReservations != null ? totalReservations : "Not available at this moment" }}
          </b-badge>

        </b-form-group>
      </b-col>
    </b-row>



    <b-row class="mt-5 w-100">

      <b-col cols="3">
        <b-form-group :description="msg('BnB Style rent (default ab 1 Nacht)') ">
          <b-form-checkbox
              v-model="realEstate.bnbStyle"
              name="check-button" switch
              @change="onValueUpdatedBnb">
          </b-form-checkbox>
        </b-form-group>

      </b-col>

      <b-col cols="3">
        <b-form-group :description="msg('30 Nächte Minimum') ">
          <b-form-checkbox
              v-model="realEstate.bnbStyle30"
              name="check-button" switch
              @change="onValueUpdatedBnb30">
          </b-form-checkbox>
        </b-form-group>

      </b-col>
    </b-row>
    <b-row class="mt-5 w-100">

      <b-col cols="12" md="6" lg="3">
        <b-form-group :label="msg('CheckIn time')" label-for="messageTemplate-company">
          <v-select
              :dir="isRTL ? 'rtl' : 'ltr'"
              :clearable="false"
              :options="timeOptions"
              v-model="realEstate.checkInTime"
              class="w-100"
              label="label"
              :reduce="(branch) => branch.value"
          ></v-select>
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6" lg="3">
        <b-form-group :label="msg('CheckOut time')" label-for="messageTemplate-company">

          <v-select
              :dir="isRTL ? 'rtl' : 'ltr'"
              :clearable="false"
              :options="timeOptions"
              v-model="realEstate.checkOutTime"
              class="w-100"
              label="label"
              :reduce="(branch) => branch.value"
          ></v-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6" lg="3">
        <b-form-group :label="msg('Early CheckIn time')" label-for="messageTemplate-company">
          <v-select
              :dir="isRTL ? 'rtl' : 'ltr'"
              :clearable="false"
              :options="timeOptions"
              v-model="realEstate.earlyCheckInTime"
              class="w-100"
              label="label"
              :reduce="(branch) => branch.value"
          ></v-select>
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6" lg="3">
        <b-form-group :label="msg('Late CheckOut time')" label-for="messageTemplate-company">

          <v-select
              :dir="isRTL ? 'rtl' : 'ltr'"
              :clearable="false"
              :options="timeOptions"
              v-model="realEstate.lateCheckOutTime"
              class="w-100"
              label="label"
              :reduce="(branch) => branch.value"
          ></v-select>
        </b-form-group>
      </b-col>
      <b-col cols="12">
        <b-form-group label="CheckIn Details" label-for="realEstate-buy-price">
          <b-textarea id="realEstate-buy-price" v-model="realEstate.realEstateTreasure.keyCode"
                      @change="onValueUpdated"/>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="Wifi Username" label-for="realEstate-buy-price">
          <b-form-input id="realEstate-buy-price" v-model="realEstate.realEstateTreasure.wifiUsername"
                        @change="onValueUpdated"/>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group label="Wifi Password" label-for="realEstate-buy-price">
          <b-form-input id="realEstate-buy-price" v-model="realEstate.realEstateTreasure.wifiPassword"
                        @change="onValueUpdated"/>
        </b-form-group>
      </b-col>


      <b-col cols="3">
        <b-form-group :label="msg('One payment') +' in %'" label-for="realEstate-buy-price">
          <b-form-input id="realEstate-buy-price" type="number" v-model="realEstate.realEstateTreasure.oneTimePayment"
                        @change="onValueUpdated"/>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group :label="msg('Discount 3-6 months') +' in %'" label-for="realEstate-buy-price">
          <b-form-input id="realEstate-buy-price" type="number" v-model="realEstate.realEstateTreasure.discount3"
                        @change="onValueUpdated"/>
        </b-form-group>
      </b-col>

      <b-col cols="3">
        <b-form-group :label="msg('Discount 6-12 months') +' in %'" label-for="realEstate-buy-price">
          <b-form-input id="realEstate-buy-price" type="number" v-model="realEstate.realEstateTreasure.discount6"
                        @change="onValueUpdated"/>
        </b-form-group>
      </b-col>

      <b-col cols="3">
        <b-form-group :label="msg('Discount 12+ months') +' in %'" label-for="realEstate-buy-price">
          <b-form-input id="realEstate-buy-price" type="number" v-model="realEstate.realEstateTreasure.discount12"
                        @change="onValueUpdated"/>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <b-form-group :label="msg('Review Online')" label-for="realEstate-buy-price">
          <b-form-textarea v-model="realEstate.realEstateTreasure.review" @change="()=>onValueUpdated"
                           size="sm"></b-form-textarea>

        </b-form-group>
      </b-col>

    </b-row>
    <b-card-title class="mt-3">{{ msg('Cancellation Policy') }}</b-card-title>

    <b-row>
      <b-col>
        <b-form>
          <b-form-checkbox-group v-model="selectedOptions">
            <b-form-checkbox value="threeDays">{{ msg('3 Days') }}</b-form-checkbox>
            <b-form-checkbox value="sevenDays">{{ msg('7 Days') }}</b-form-checkbox>
            <b-form-checkbox value="fourteenDays">{{ msg('14 Days') }}</b-form-checkbox>
            <!-- Always checked and no input needed for non-refundable -->
            <b-form-checkbox value="nonRefundable" disabled>{{ msg('Non - refundable') }}</b-form-checkbox>
          </b-form-checkbox-group>

          <b-row class="mt-3">
            <!-- Input for threeDays -->
            <b-col v-if="selectedOptions.includes('threeDays')" md="2">
              <b-form-group :label="msg('3 Days Fee Percentage')">
                <b-form-input
                    type="number"
                    v-model="realEstate.realEstateCancel.threeDaysFeePercent"
                    :placeholder="msg('Enter percentage')"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <!-- Input for sevenDays -->
            <b-col v-if="selectedOptions.includes('sevenDays')" md="2">
              <b-form-group :label="msg('7 Days Fee Percentage')">
                <b-form-input
                    type="number"
                    v-model="realEstate.realEstateCancel.sevenDaysFeePercent"
                    :placeholder="msg('Enter percentage')"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <!-- Input for fourteenDays -->
            <b-col v-if="selectedOptions.includes('fourteenDays')" md="2">
              <b-form-group :label="msg('14 Days Fee Percentage')">
                <b-form-input
                    type="number"
                    v-model="realEstate.realEstateCancel.fourteenDaysFeePercent"
                    :placeholder="msg('Enter percentage')"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'realEstateTreasureRent',
  components: {},
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    loaded: false,
    channelLoading: false,
    totalReservations: null,
    selectedOptions: ['nonRefundable'], // To hold selected checkboxes
    timeOptions:
        [
          {label: "00:00", value: "00:00"},
          {label: "00:30", value: "00:30"},
          {label: "01:00", value: "01:00"},
          {label: "01:30", value: "01:30"},
          {label: "02:00", value: "02:00"},
          {label: "02:30", value: "02:30"},
          {label: "03:00", value: "03:00"},
          {label: "03:30", value: "03:30"},
          {label: "04:00", value: "04:00"},
          {label: "04:30", value: "04:30"},
          {label: "05:00", value: "05:00"},
          {label: "05:30", value: "05:30"},
          {label: "06:00", value: "06:00"},
          {label: "06:30", value: "06:30"},
          {label: "07:00", value: "07:00"},
          {label: "07:30", value: "07:30"},
          {label: "08:00", value: "08:00"},
          {label: "08:30", value: "08:30"},
          {label: "09:00", value: "09:00"},
          {label: "09:30", value: "09:30"},
          {label: "10:00", value: "10:00"},
          {label: "10:30", value: "10:30"},
          {label: "11:00", value: "11:00"},
          {label: "11:30", value: "11:30"},
          {label: "12:00", value: "12:00"},
          {label: "12:30", value: "12:30"},
          {label: "13:00", value: "13:00"},
          {label: "13:30", value: "13:30"},
          {label: "14:00", value: "14:00"},
          {label: "14:30", value: "14:30"},
          {label: "15:00", value: "15:00"},
          {label: "15:30", value: "15:30"},
          {label: "16:00", value: "16:00"},
          {label: "16:30", value: "16:30"},
          {label: "17:00", value: "17:00"},
          {label: "17:30", value: "17:30"},
          {label: "18:00", value: "18:00"},
          {label: "18:30", value: "18:30"},
          {label: "19:00", value: "19:00"},
          {label: "19:30", value: "19:30"},
          {label: "20:00", value: "20:00"},
          {label: "20:30", value: "20:30"},
          {label: "21:00", value: "21:00"},
          {label: "21:30", value: "21:30"},
          {label: "22:00", value: "22:00"},
          {label: "22:30", value: "22:30"},
          {label: "23:00", value: "23:00"},
          {label: "23:30", value: "23:30"}
        ],


  }),
  watch: {
    // Watch for changes in selectedOptions and update corresponding booleans
    selectedOptions(newSelectedOptions) {
      // Set booleans to true if the corresponding option is selected, false otherwise
      this.realEstate.realEstateCancel.threeDays = newSelectedOptions.includes('threeDays');
      this.realEstate.realEstateCancel.sevenDays = newSelectedOptions.includes('sevenDays');
      this.realEstate.realEstateCancel.fourteenDays = newSelectedOptions.includes('fourteenDays');
    }
  },
  computed: {
    ...mapGetters('realEstate', ['getAllTypes']),
    ...mapGetters('data', ['getAllBranches']),
    ...mapGetters('data', ['getAllCountries', 'getAllLanguage']),
    allBranches() {
      return Object.values(this.getAllBranches)
    },
    allCountries() {
      return Object.values(this.getAllCountries)
    },
    realEstate: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
  },
  created() {
    this.loaded = true
    this.fetchReservationCount()
    // Set default percentage values if they are null

  },
  methods: {
    ...mapActions('nuki', {_loadNukiList: 'getNukiList', _sendMail: 'sendMail'}),
    ...mapActions('realEstate', ['fetchChannelContracts', 'getRealEstateReservationCountById']),

    fetchReservationCount() {
      let $this = this;
      this.getRealEstateReservationCountById(this.realEstate.id)
          .then(response => {
            $this.totalReservations = response.totalReservations;

          });

    },
    fetchChannelReservations() {
      this.channelLoading = true; // Start loading
      this.fetchChannelContracts(this.realEstate.id)
          .then(() => {
            // Handle success if needed
          })
          .catch(error => {
            // Handle error if needed
            console.error("An error occurred:", error);
          })
          .finally(() => {
            this.channelLoading = false; // Stop loading on either success or error
          });
    },
    onValueUpdated(args) {
      this.$emit('change', args)
    },
    onValueUpdatedBnb30(args) {
      if (this.realEstate.bnbStyle30)
        this.realEstate.bnbStyle = true
      this.$emit('change', args)
    },
    onValueUpdatedBnb(args) {
      if (!this.realEstate.bnbStyle)
        this.realEstate.bnbStyle30 = false
      this.$emit('change', args)
    },

  }
}
</script>

<style>
.realEstate-description .ql-editor {
  min-height: 200px;
}
</style>
